import { render, staticRenderFns } from "./UsableGifts.vue?vue&type=template&id=45fb52d0&"
import script from "./UsableGifts.vue?vue&type=script&lang=js&"
export * from "./UsableGifts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports